const CIVIL = [
  { id: 'marie',       label: 'Marié(e)' },
  { id: 'pacse',       label: 'Pacsé(e)' },
  { id: 'celibataire', label: 'Célibataire' },
  { id: 'divorce',     label: 'Divorcé(e)' },
  { id: 'veuf',        label: 'Veuf/ve' },
]
const EMPLOYMENT = [
  { id: 'salarie', label: 'Salarié' },
  { id: 'independant', label: 'Indépendant' },
  { id: 'dirigeant', label: 'Dirigeant' },
  { id: 'retraite', label: 'Retraité' },
  { id: 'autre', label: 'Autre' },
]
const OWNERSHIP = [
  { id: 'proprietaire', label: 'Propriétaire' },
  { id: 'locataire',    label: 'Locataire' },
  { id: 'autre',        label: 'Autre' },
]

function Seg({ options, value, onChange }) {
  return (
    <span className="inline-flex flex-wrap gap-1 rounded-lg bg-bg p-0.5">
      {options.map(o => {
        const on = o.id === value
        return (
          <button
            key={o.id}
            onClick={() => onChange(o.id)}
            className={`rounded-md px-2.5 py-1.5 text-[12px] sm:py-1 ${on ? 'bg-white font-medium text-ink shadow-[0_1px_1.5px_rgba(0,0,0,.05)]' : 'text-muted'}`}
          >{o.label}</button>
        )
      })}
    </span>
  )
}

export default function ProfileBar({ profile, onChange }) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-xl border border-line bg-white px-4 py-2.5 sm:gap-3.5">
      <span className="text-[10.5px] font-semibold uppercase tracking-[1.4px] text-fiscal-fg">Profil client</span>
      <Seg options={CIVIL}      value={profile.civilStatus} onChange={(v) => onChange({ ...profile, civilStatus: v })} />
      <span className="inline-flex flex-wrap gap-1 rounded-lg bg-bg p-0.5">
        <button onClick={() => onChange({ ...profile, hasChildren: true })}
          className={`rounded-md px-2.5 py-1.5 text-[12px] sm:py-1 ${profile.hasChildren ? 'bg-white font-medium text-ink' : 'text-muted'}`}>Avec enfants</button>
        <button onClick={() => onChange({ ...profile, hasChildren: false })}
          className={`rounded-md px-2.5 py-1.5 text-[12px] sm:py-1 ${!profile.hasChildren ? 'bg-white font-medium text-ink' : 'text-muted'}`}>Sans enfants</button>
      </span>
      <Seg options={EMPLOYMENT} value={profile.employment}  onChange={(v) => onChange({ ...profile, employment: v })} />
      <Seg options={OWNERSHIP}  value={profile.ownership}   onChange={(v) => onChange({ ...profile, ownership: v })} />
      <span className="ml-auto text-[11.5px] text-muted">Le formulaire s'adapte automatiquement</span>
    </div>
  )
}
